export default "__VITE_ASSET__B8EVOwT2__"